;(function(EG) {
  'use strict';

  var $delegate,
    $selfRegistrationView,
    createUserModel,
    selfRegistrationUtils,
    cdfCollection,
    cdfViewUtils,
    cdfUtils,
    userCDFs,
    titlesModel,
    userTitleModel,
    userInfoModel,
    captchaFieldsModel,
    messageTemplate,
    captchaTemplate,
    $commonMsgContainer,
    $selfRegForm,
    $privacyPolicy,
    $captchaError,
    captchaAttrs,
    turnstileAttrs,
      recaptchaAttr,
      recaptchaWidget,
    captchaFields,
    templateConfig,
      companySSOSettings,
      AUTHENTICATION_MODES,
      CREATE_USER,
      initialValidations,
    $privacyPolicyContainer,
      loginChanged,
      isCaptchaVerified = true,
      recaptchaResponse,
    relaxEmailIdFeatureEnabled;

  $delegate = $('body');
  messageTemplate = Handlebars.templates['partials/common/page-message'];
  captchaTemplate = Handlebars.templates['partials/common/captcha-content'];
  selfRegistrationUtils = EG.Users.Profile.View.Utils.UserSelfRegistration;
  cdfViewUtils = EG.Users.Profile.View.Utils.CustomDataFieldsV2;
  cdfUtils = EG.Users.Utils.CustomDataFields;
  userCDFs = new EG.Users.Profile.Collections.UserCustomDataFields();
  templateConfig = EG.Users.Constants.uiTemplate;
  relaxEmailIdFeatureEnabled = EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type) && EG.Users.Constants.user_guestbooking_relax_unique_email_check_enabled;
  AUTHENTICATION_MODES = [
    {
      code: 'SSO',
      label: 'SSO'
    },
    {
      code: 'LOGIN',
      label: 'LOGIN'
    }
  ];

  CREATE_USER = {
    MESSAGES: {
      error: 'error',
      success: 'success'
    },
    commonMsgContainerId: 'page-msg'
  };



  function companySelfRegistration() {
    // Setting it to false for perpetual link registration
    if(EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)){
      EG.Users.Utils.enhanceSelfRegitrationConfigForGlobalGuest(templateConfig);
    }

    EG.Users.Libs.ValidationBuilder.setValidationRules(
      EG.user.userId,
      EG.user.companyId,
      EG.Users.Constants.validationRules
    );
    initPage();
    initModels();
    initView();
    /**Events**/
    setupEventListeners();
  };

  function hideNeutralGenderComponents() {
      $('#user_gender_list').addClass('hidden');
      $('#user_title_list').addClass('hidden');
      $('#airline_info_header').addClass('hidden');
  }

  $(document).ready(function() {
        companySelfRegistration();
  });


  function  initPage() {
    var analyticsOptions;
    $commonMsgContainer = $('#' + CREATE_USER.commonMsgContainerId);
    selfRegistrationUtils.clearPageMessage($commonMsgContainer);
    EG.Users.Utils.showLoadingScreen(EG.Users.Profile.Globals.InterstitialContainerId);
    // Initialize and send analytics data
    EG.Users.Profile.userAnalytics = new EG.Users.Analytics.UserAnalytics(
        getAnalyticsKey('PAGE_NAME')
    );
    EG.Users.Profile.userAnalytics.initialize();
    EG.Users.Profile.userAnalytics.send();

    $selfRegistrationView = $('#user-self-registration-form');
    disableActionButtons();

    analyticsOptions = {
      linkId: getAnalyticsKey('VIEW'),
      linkObj: null
    };
    uitk.analytics.track('a', analyticsOptions);
  }

  function initModels() {
    var titles, companyId, hashCode;
    companyId = EG.Users.Utils.getCompanyId();
    userInfoModel = new EG.Users.Models.CompanyCreateUser();
    hashCode = EG.Users.Constants.hashCode;
    createUserModel = new EG.Users.Models.CreateUser(
      {},
      {
        inviteType: EG.Users.Constants.SelfRegistrationInvite.types.companyLink
      }
    );
    captchaFieldsModel = new EG.Users.Models.CaptchaFields();
    createUserModel.setCompanyId(companyId);
    userInfoModel.setStatus(EG.Users.Profile.Constants.USER_STATUS.pending.value);
    titlesModel = new EG.Users.Profile.Collections.Title(EG.Users.Constants.titles);
    userTitleModel=EG.Users.Constants.titles.concat([]);
    userTitleModel.unshift({
      code: EG.Users.Constants.DEFAULT_VALUE,
      label: uitk.i18n.msg('profile_please_select'),
      selected: false
    });
    userTitleModel = new EG.Users.Profile.Collections.Title(userTitleModel);
    companySSOSettings = new EG.Users.Profile.Models.CompanySSOSettings(companyId, hashCode);
    cdfCollection = new EG.Users.Profile.Collections.CDFDefinitions(
      {},
      {
        companyId: companyId
      }
    );
    cdfCollection.comparator = 'rank';
  }

  function renderCreateUserForm(){
    var html, $phoneInputs, titles, templateData, captchaData, companySSOPolicySettings,companySSOSettings,authentication_modes,user_titles;
    companySSOSettings = getCompanySSOSettings();
    titles = titlesModel.toJSON();
    user_titles = userTitleModel.toJSON();
    templateData = {};
    titles.unshift({
      code: '',
      label: uitk.i18n.msg('profile_please_select'),
      selected: true
    });

    if(EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)){
      templateData.use_non_corporate_email = true;
    }

    templateData.titles = titles;
    templateData.user_titles = user_titles;
    templateData.regionalNameLabel = EG.Users.Utils.getRegionalNameLabel(EG.user.productId);
    templateData.genders = EG.Users.Utils.transformGendersInfo();
    templateData.user_genders = EG.Users.Utils.transformUserGendersInfo();
    $privacyPolicyContainer = $('.privacy-policy-container');

    companySSOPolicySettings = getCompanySSOPolicySettings();
    if (companySSOPolicySettings) {
      authentication_modes = getAuthenticationModes();
      templateData.authentication_modes = {
        values: JSON.stringify(authentication_modes.modes),
        selectedValue: JSON.stringify(authentication_modes.default),
        customValue: JSON.stringify(authentication_modes.custom),
        options: authentication_modes.modes
      };
      toggleSSOFieldValidation(companySSOPolicySettings?.default_authentication_mode);
    } else {
      templateConfig.user_self_registration.login_credentials.authentication = false;
      templateConfig.user_self_registration.login_credentials.single_sign_on_id = false;
    }
    if(!relaxEmailIdFeatureEnabled){
        templateConfig.user_self_registration.personal_info.login = false;
    }
    EG.Users.Constants.uiTemplate.user_self_registration.login_credentials.authentication.order = 2;
    html = EG.UIService.getHTMLFromConfig({
      config: EG.Users.Constants.uiTemplate,
      data: templateData,
      template: 'user_self_registration',
      checkPossiblePaths: true
    });
    $selfRegistrationView.html(html);
    uitk.initDOB();

    $privacyPolicyContainer.removeClass('hidden');


    $phoneInputs = $('#mobile-phone-container').find('.input-phone');

    EG.Users.Profile.View.Utils.PersonalInfo.initPhonePlugin($phoneInputs);
    $commonMsgContainer = $('#page-msg');
    $selfRegForm = $('#user-self-registration-form');
    $privacyPolicy = $('#privacy_policy');

    clearPageMessage();
    clearPageMessage();
    initValidations();
    captchaData = {
      captchaContent: $('#captcha-content').html(),
      captchaValidationUrl: $('#captcha-url').html()
    };
    $('#captcha-content').empty();
    $('#captcha-url').empty();

    renderCaptcha($('#captcha-parent-self-registration'), captchaData);

    if (cdfViewUtils.isCDFEnabled(templateConfig)) {
      initCustomDataFields();
    }
    filterValidations();
    EG.Users.Utils.assignPrivacyAndTOCTarget({
      privacyPolicy: '#users-privacy-policy',
      toc: '#users-toc'
    });
    EG.Users.Utils.hideLoadingScreen(EG.Users.Profile.Globals.InterstitialContainerId);
    initialValidations = Object.assign({}, userInfoModel.validation);

    if(authentication_modes.default){
      showHideSSOField(authentication_modes.default.code);
    }
    hideNeutralGenderComponents();
  }

  function showHideSSOField(value){
    var $ssoIdBlock = $('#single_sign_on_id_block');
    var $ssoId = $('#single_sign_on_id');
    if (value != 'SSO') {
      $ssoId.val(null);
      $ssoIdBlock.addClass('hidden');
    } else {
      $ssoIdBlock.removeClass('hidden');
    }
    toggleSSOFieldValidation(value);
  }

  function populateLogin(value){
    if(!relaxEmailIdFeatureEnabled || loginChanged){
      return;
    }
    $('#login').val(value);
  }

  function toggleSSOFieldValidation(authenticationMode){
    if(authenticationMode == 'SSO'){
      EG.Users.Constants.uiTemplate.user_self_registration.login_credentials.single_sign_on_id.mandatory = true;
    }else{
      EG.Users.Constants.uiTemplate.user_self_registration.login_credentials.single_sign_on_id.mandatory = false;
    }
  }

  function displayPageError(){
    EG.Users.OmnitureUtil.omnitureTrackSomethingWentWrong();
    selfRegistrationUtils.displayMessage({
      type: CREATE_USER.MESSAGES.error,
      message: uitk.i18n.msg('EGE_USERS_ERR_DEFAULT'),
      commonMsgContainerId: $commonMsgContainer
    });
    EG.Users.Utils.hideLoadingScreen(EG.Users.Profile.Globals.InterstitialContainerId);
  }

  function initView() {
    var companySSOSettingsPromise;
    companySSOSettingsPromise = companySSOSettings.fetch();
    $.when(
        companySSOSettingsPromise
    ).then(renderCreateUserForm, displayPageError);
  }

  function initCustomDataFields() {
    cdfCollection.fetchData().then(function(cdfs) {
      renderCustomDataFields(cdfs);
    });
  }

  function getCompanySSOSettings() {
    return companySSOSettings.toJSON();
  }

  function getCompanySSOPolicySettings() {
    var companySSOSettings;

    companySSOSettings = getCompanySSOSettings();

    return companySSOSettings.company_ssopolicy_response;
  }

  function getAuthenticationModes() {
    var companySSOPolicySettings, authentication_modes, defaultMode;

    companySSOPolicySettings = getCompanySSOPolicySettings();

    if (!companySSOPolicySettings || !companySSOPolicySettings.sso_or_login) {
      return {
        modes: AUTHENTICATION_MODES
      };
    }

    authentication_modes = AUTHENTICATION_MODES.concat([]);

    defaultMode = _.findWhere(authentication_modes, {
      code: companySSOPolicySettings.default_authentication_mode
    });

    if (_.isEmpty(defaultMode)) {
      // Defaulted to LOGIN
      defaultMode = AUTHENTICATION_MODES[1];
    }
    defaultMode.selected = true;

    return {
      modes: authentication_modes,
      default: defaultMode,
      custom: AUTHENTICATION_MODES[0]
    };
  }

  function renderCustomDataFields(cdfs) {
    var cdfsOnProfile;

    cdfsOnProfile = EG.Users.Utils.CustomDataFields.getCDFSOnProfile(cdfs);

    cdfsOnProfile = _.filter(cdfsOnProfile, function(cdf) {
      return cdf.validations.readOnly.travelers;
    });

    _.each(cdfsOnProfile, function(cdf) {
      cdfViewUtils.renderCDF({
        $container: $('#custom-data-fields-container'),
        cdf: cdf,
        onRender: applyCDFValidations
      });
    });
  }

  function initValidations() {
    userInfoModel.validation = {};
    EG.Users.Libs.ValidationBuilder.bindValidation({
      userId: EG.user.userId,
      model: userInfoModel,
      $view: $('#user-self-registration-form'),
      validationConfigCategory: 'user_self_registration'
    });

  }

  function getActionBtns() {
    return $('#register-user');
  }

  function getLoginField() {
    return $('#login');
  }

  function renderCaptcha($captchaParent, captchaContent) {
    if(EG.Users.Constants.recaptcha_enabled){
      $captchaParent.empty().append(
          captchaTemplate({
            recaptcha_enabled: true
          })
      );
      loadRecaptcha(renderRecaptcha);
    }else if(EG.Users.Constants.turnstile_enabled){
      $captchaParent.empty().append(
          captchaTemplate({
            turnstile_enabled: true
          })
      );
      renderTurnstile();
    }else{
      EG.Users.Utils.InitCaptcha(captchaContent.captchaValidationUrl.trim());
      captchaContent = captchaContent ? captchaContent : captchaData;
      captchaContent.audioCaptchaEnabled = EG.Users.Constants.audio_captcha_enabled;
      $captchaParent.empty().append(
          captchaTemplate({
            captchaFields: captchaContent,
            turnstile_enabled: false,
            recaptcha_enabled: false
          })
      );
    }
    $captchaError = $('#captcha-error');
    $captchaError.addClass('hidden');
  }

  function renderTurnstile() {
    const siteKey = EG.Users.Constants.turnstile_site_key;
    turnstile.render('#turnstile-block', {
      sitekey: siteKey,
      theme: 'light',
      callback: function (token) {
        isCaptchaVerified = true;
        enableDisableSubmitButton();
      },
      'error-callback': function () {
        isCaptchaVerified = false;
        enableDisableSubmitButton();
      }
    });
  }

  function refreshRecaptcha() {
    isCaptchaVerified = false;
    if (typeof grecaptcha !== 'undefined' && typeof recaptchaWidget !== 'undefined') {
      // Check if grecaptcha and recaptchaWidget are defined
      window.grecaptcha.reset(recaptchaWidget);
    }
  }

  function loadRecaptcha(callback) {
    if (typeof grecaptcha !== 'undefined') {
      callback();
    } else {
      var script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit&hl=${EG.currentLocale}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      // Define the global onload function for the reCAPTCHA script
      window.recaptchaLoaded = function () {
        callback();
      };
    }
  }
  function renderRecaptcha() {
    const siteKey = EG.Users.Constants.recaptcha_client_key;
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.ready(function(){
        refreshRecaptcha();
        recaptchaWidget  = grecaptcha.render('recaptcha-block', {
          'sitekey': siteKey,
          'callback': function (token) {
            isCaptchaVerified = true;
            enableDisableSubmitButton();
          },
          'expired-callback' : function () {
            isCaptchaVerified = false;
            enableDisableSubmitButton();
          },
          'error-callback' : function () {
            isCaptchaVerified = false;
            enableDisableSubmitButton();
          },
        });
      });
    }
  }


  function enableDisableSubmitButton(){
    const $submitButton = getActionBtns();
    const $privacyPolicyCheckbox = $("#privacy_policy");
    const privacyPolicyChecked = $privacyPolicyCheckbox.is(':checked');
    var turnstileValidated = true;
    if((EG.Users.Constants.recaptcha_enabled || EG.Users.Constants.turnstile_enabled) && !isCaptchaVerified){
      turnstileValidated = false;
    }

    if(privacyPolicyChecked && turnstileValidated){
      $submitButton.removeAttr('disabled');
    }else{
      $submitButton.attr('disabled', 'disabled');
    }
  }

  function getFormValues() {
    var formValues;

    formValues = EG.Users.Utils.parseForm({
      formName: EG.Users.Profile.Constants.PROFILE_FORM_NAME,
      attributes: {
        self_registration: userInfoModel.toJSON()
      },
      parsers: {
        default: EG.Users.Utils.parseDefaultFormAttributes
      }
    });

    return formValues.self_registration;
  }

  function disableActionButtons() {
    var $actionBtns;

    $actionBtns = getActionBtns();

    $actionBtns.attr('disabled', 'disabled');
  }

  function setupEventListeners() {
    $delegate
      .off('change', '#privacy_policy')
      .on('change', '#privacy_policy', function(evt) {
        enableDisableSubmitButton();
      })

      .off('click', '#register-user')
      .on('click', '#register-user', saveUserRegistration);

    $delegate.off('change', '#user_authentication_mode').on('change', '#user_authentication_mode', function(evt) {
      showHideSSOField(evt.target.value);
    });

    $delegate.on('change', '#email', function(evt) {
      populateLogin(evt.target.value);
    });

    $delegate.on('change', '#login', function(evt) {
      loginChanged = true;
    });

    $delegate.off('change', '#gender').on('change', '#gender', function () {
      EG.Users.Utils.handleSelectionOfGender($('#gender'),$('#personal_title_code'),userInfoModel)
    });
  }


  function saveUserRegistration(evt) {
    var formValues, inviteCode, mobileNumber, analyticsOptions;
    evt.preventDefault();

    formValues = getFormValues();
    if(!relaxEmailIdFeatureEnabled){
        formValues.login = formValues.email;
    }
    var companySSOPolicySettings = getCompanySSOPolicySettings();

    //neutral gender conditions
    if (formValues.gender_code === EG.Users.Constants.UNSPECIFIED_GENDER_CODE || formValues.gender_code === EG.Users.Constants.UNDISCLOSED_GENDER_CODE) {
      if (EG.user.productId != EG.Users.Constants.US_PROUDUCT_ID) {
        userInfoModel.validation["user_title_code"] = (EG.Users.Profile.Collections.Title.applyAirlineTitleValidations());
      }
      userInfoModel.validation["user_gender_code"] = (EG.Users.Utils.applyAirlineGenderValidations());
    }
    if(formValues.user_authentication_mode == 'SSO' || companySSOPolicySettings.policy_type == 'ONLY_SSO'){
      if(initialValidations['single_sign_on_id']){
        if(formValues.type && formValues.type == 'GLOBAL_GUEST'){
          userInfoModel.validation['single_sign_on_id'] = [];
        }else{
          userInfoModel.validation['single_sign_on_id'] = initialValidations['single_sign_on_id'];
          userInfoModel.validation.single_sign_on_id[0].required=true;
        }
      }
    }else{
      userInfoModel.validation['single_sign_on_id'] = [];
    }

    mobileNumber = {};

    mobileNumber = formValues.number;

    if (mobileNumber) {
      formValues.mobile_phone = {
        number: mobileNumber
      };

      if (EG.isNA) {
        formValues.mobile_phone = {
          number: mobileNumber,
          country_prefix: formValues.country_prefix,
          area_code: formValues.area_code
        };
      }
    }

    var companyPolicy = getCompanySSOPolicySettings();
    var userAuthenticationMode = formValues.user_authentication_mode;
    if(companyPolicy.policy_type != 'ONLY_SSO' &&  userAuthenticationMode != 'SSO'){
      formValues.single_sign_on_id = undefined;
    }
    resetModelData();

    if(EG.Users.Constants.recaptcha_enabled){
      setRecaptchaAttrs();
    }else if(EG.Users.Constants.turnstile_enabled){
      setTurnstileAttrs();
    }else{
      setCaptchaAttrs();
    }

    userInfoModel.set(formValues, {
      validate: true
    });

    inviteCode = EG.Users.Utils.getParameterByName('c');
    userInfoModel.setInviteCode(inviteCode);
    EG.Users.Utils.populateGenderNeutralFields(userInfoModel);
    if (isFormValid()) {
        EG.Users.Utils.exchangeGenderNeutralFieldsWithNormalGenderField(userInfoModel.attributes);
      saveUser();
    } else {
      EG.Users.Utils.scrollTop($('.invalid:first')[0]);
    }

    analyticsOptions = {
      linkId: getAnalyticsKey('SUBMIT'),
      linkObj: null
    };

    uitk.analytics.track('a', analyticsOptions);
  }

  function setCaptchaAttrs() {
    captchaAttrs = {
      captcha_token: $('#nucaptcha-token').val(),
      captcha_answer: $('.self-registration-captcha #nucaptcha-answer').val(),
      nds_pmd: $('[name=nds-pmd]').val(),
      nds_id: $('[name=ndsid]').val()
    };
  }

  function setTurnstileAttrs(){
    const turnstileResponse = $("input[name=cf-turnstile-response]").val();
    const isLocalhost = EG.Users.Constants.isLocalhost;
    turnstileAttrs = {
      turnstile_shown : true,
      cf_turnstile_response : turnstileResponse,
      is_localhost : isLocalhost
    }
  }

  function setRecaptchaAttrs(){
    var grecaptchaResponse = $('textarea[name=g-recaptcha-response]').val();
    const isLocalhost = EG.Users.Constants.isLocalhost;
    recaptchaAttr = {
      recaptcha_shown : true,
      recaptcha_response : grecaptchaResponse,
      is_localhost : isLocalhost
    }
  }

  function saveUser() {
    var cdfData;

    EG.Users.Utils.showLoadingScreen(EG.Users.Profile.Globals.InterstitialContainerId);

    cdfData = transformCDFData(userCDFs.toJSON());

    createUserModel.set({
      user_info: userInfoModel.toJSON(),
      captcha_info: captchaAttrs,
      turnstile_info: turnstileAttrs,
      recaptcha_info: recaptchaAttr,
      user_business_info: {
        user_custom_data_fields: cdfData
      }
    });

    createUserModel.setInviteType(EG.Users.Constants.SelfRegistrationInvite.types.companyLink);

    createUserModel
      .saveSelfRegistration()
      .then(displaySuccess, displayError)
      .always(function() {
        resetModelData();
        EG.Users.Utils.hideLoadingScreen(EG.Users.Profile.Globals.InterstitialContainerId);
      });
  }

  function displayError(response) {
    var errorDescription, errorJSON, analyticsOptions;
    errorDescription = 'EGE_USERS_ERR_DEFAULT';
    errorJSON = EG.Users.Utils.getResponseJSON(response);
    if (errorJSON && errorJSON.captcha_response) {
      captchaFields = captchaFieldsModel.setData(errorJSON.captcha_response).toJSON();
      renderCaptcha($('#captcha-parent-self-registration'), captchaFields);
    }
    if(EG.Users.Constants.recaptcha_enabled || EG.Users.Constants.turnstile_enabled){
      renderCaptcha($('#captcha-parent-self-registration'), null);
    }

    if (errorJSON && errorJSON.error) {
      errorDescription = (relaxEmailIdFeatureEnabled && EG.Users.Profile.Error.global_guest[errorJSON.error.toLowerCase()]) || EG.Users.Profile.Error.Descriptions[errorJSON.error.toLowerCase()] || errorDescription;
    }
    if (errorDescription === 'CAPTCHA_INCORRECT') {
      analyticsOptions = {
        linkId: getAnalyticsKey('INCORRECT_CAPTCHA_ENTERED'),
        linkObj: null
      };
      uitk.analytics.track('a', analyticsOptions);
    } else if(errorDescription === 'EGE_USERS_ERR_DEFAULT') {
      EG.Users.OmnitureUtil.omnitureTrackSomethingWentWrong();
    }

    displayMessage({
      type: EG.Users.Constants.alertType.ERROR,
      message: uitk.i18n.msg(errorDescription)
    });
  }

  function displaySuccess(response) {
    if (response && response.captcha_response) {
      captchaFields = captchaFieldsModel.setData(response.captcha_response).toJSON();
      renderCaptcha($('#captcha-parent-self-registration'), captchaFields);
    }
    if (EG.Users.Constants.turnstile_enabled || EG.Users.Constants.recaptcha_enabled) {
      renderCaptcha($('#captcha-parent-self-registration'), null);
    }
    displayMessage({
      type: EG.Users.Constants.alertType.SUCCESS,
      message: uitk.i18n.msg('user_self_registration_user_creation_successful', {
        arg0: response.user_info.first_name + ' ' + response.user_info.last_name
      })
    });
    resetForm();
  }

  function displayMessage(options) {
    clearPageMessage();

    $commonMsgContainer.append(
      messageTemplate({
        type: options.type,
        message: options.message
      })
    );
    EG.Users.Utils.scrollTop($commonMsgContainer[0])
  }

  function resetForm() {
    const title= $('#personal_title_code');
    if (title.val() === EG.Users.Constants.NEUTRAL_TITLE_CODE) {
      title.prop("disabled", false)
      title.find(":selected").remove();
      title.val(EG.Users.Constants.MR_TITLE_CODE).change();
    }
    $selfRegForm[0].reset();
    resetModelData();
    $privacyPolicy.change();
    let authentication_modes = getAuthenticationModes();
    if(authentication_modes.default){
      showHideSSOField(authentication_modes.default.code);
    }
  }

  function clearPageMessage() {
    $commonMsgContainer.html('');
  }

  function isCaptchaValid() {
    if (captchaAttrs.captcha_answer.length < 1) {
      $captchaError.removeClass('hidden');
      return false;
    }
    return true;
  }

  function isFormValid() {
    var isFormValid;

    isFormValid = true;
    if (!userInfoModel.isValid()) {
      isFormValid = false;
      if(!_.isEmpty(userInfoModel.validationError.date_of_birth)) {
        if(userInfoModel.validationError.date_of_birth[0] === 'global_guest_user_age_limit') {
          let err = $('.date-of-birth-error-message')
          let text = err.text().replace('{0}',18);
          err.text(text);
        }
      }
    }

    if (!EG.Users.Constants.turnstile_enabled && !EG.Users.Constants.recaptcha_enabled && !isCaptchaValid()) {
      isFormValid = false;
    }

    if((EG.Users.Constants.turnstile_enabled || EG.Users.Constants.recaptcha_enabled) && !isCaptchaVerified){
      isFormValid = false;
    }

    if (!isCDFValid()) {
      isFormValid = false;
    }

    return isFormValid;
  }

  function isCDFValid() {
    return cdfViewUtils.setAndValidate(userCDFs);
  }

  function resetModelData() {
    createUserModel.resetData();
    userInfoModel.resetData();
    userInfoModel.setStatus(EG.Users.Profile.Constants.USER_STATUS.pending.value);
  }

  function applyCDFValidations(cdf, $container) {
    var userCDF, validations;

    userCDF = new EG.Users.Profile.Models.UserCustomDataField();
    userCDF.validation = {};

    validations = [];
    validations.push({
      required: cdf.validations.mandatory,
      msg: 'field_validation_required'
    });
    if (!cdfUtils.isCDFListField(cdf)) {
      validations.push({
        maxLength: 50,
        msg: 'cdf_validation_maxlength_invalid'
      });
    }

    userCDF.validation[cdf.id] = validations;
    userCDF.set(cdf);
    userCDFs.add(userCDF);

    EG.Users.Libs.ValidationBuilder.bindValidation({
      userId: EG.user.userId,
      model: userCDF,
      $view: $('#cdf-content'),
      validationConfigCategory: 'cdf'
    });
  }

  function transformCDFData(cdfValues) {
    var cdfData;

    cdfData = [];

    _.each(cdfValues, function(cdf) {
      if (cdf.cdfInfo) {
        cdfData.push(cdf.cdfInfo);
      }
    });

    return cdfData;
  }

  function filterValidations() {
    if(!EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)){
      userInfoModel.validation['date_of_birth'].length = 0;
    }
    return;
  }

  function getAnalyticsKey(key) {
    if(EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)){
      return EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest[key];
    }
    return EG.Users.Profile.Analytics.selfRegistrationViaCompany[key];
  }

})(EG);
